<template>
  <div>
    <modal
      :show.sync="show"
      modal-classes="modal-dialog-centered modal-lg modalflight"
      body-classes="pt-4 pb-2"
      footer-classes="border-top pt-3 pb-3"
      @close="closedModal"
    >
      <template slot="header">
        <h4 class="underline">Edit Schedule</h4>
      </template>

      <div class="row">
        <div class="col-lg-6 col-sm-9 col-12">
          <WSelect
            label="Driver"
            placeholder="Select"
            v-model="schedule.driver"
            id="edit-driver"
            name="edit-driver"
            filterable
            v-bind:class="{ 'is-invalid': $v.schedule.driver.$error }"
            :error="$v.schedule.driver.$error ? `Select a Driver` : ''"
          >
            <el-option
              v-for="(option, index) in drivers"
              :value="option._id"
              :label="option.first_name + ' ' + option.last_name"
              :key="index"
            ></el-option>
          </WSelect>
        </div>

        <div class="col-lg-2 col-sm-3 col-12 mb-4">
          <label class="title-label-np">Status</label>
          <base-switch v-model="schedule.status"></base-switch>
        </div>

        <div class="col-lg-6 col-sm-6 col-12">
          <WSelect
            label="Working Hours"
            placeholder="Select"
            v-model="schedule.working_hours"
            id="edit-workinghours"
            name="edit-workinghours"
            filterable
            v-bind:class="{ 'is-invalid': $v.schedule.working_hours.$error }"
            :error="
              $v.schedule.working_hours.$error ? `Select a Working Hours` : ''
            "
          >
            <el-option
              v-for="option in workhours"
              :value="option.value"
              :label="option.label"
              :key="option.label"
            ></el-option>
          </WSelect>
        </div>

        <div class="col-lg-6 col-sm-6 col-12">
          <WSelect
            label="Working Days"
            placeholder="Select"
            v-model="schedule.working_days"
            id="edit-workingdays"
            name="edit-workingdays"
            filterable
            v-bind:class="{ 'is-invalid': $v.schedule.working_days.$error }"
            :error="
              $v.schedule.working_days.$error ? `Select a Working Days` : ''
            "
          >
            <el-option
              v-for="(option, index) in workdays"
              :value="option.value"
              :label="option.label"
              :key="index"
            ></el-option>
          </WSelect>
        </div>

        <div class="col-lg-3 col-sm-6 col-12" v-show="working_hours">
          <base-input label="From Date">
            <flat-picker
              slot-scope="{ focus, blur }"
              @on-open="focus"
              @on-close="blur"
              :config="{
                altFormat: formatDateFlatPicker,
                altInput: true,
                dateFormat: 'Y-m-d',
                allowInput: true
              }"
              class="input-custom"
              v-model="schedule.from_date"
              id="edit-fromdate"
              name="edit-fromdate"
              placeholder="From date"
            ></flat-picker>
          </base-input>
        </div>

        <div class="col-lg-3 col-sm-6 col-12" v-show="working_hours">
          <base-input label="To Date">
            <flat-picker
              slot-scope="{ focus, blur }"
              @on-open="focus"
              @on-close="blur"
              :config="{
                altFormat: formatDateFlatPicker,
                altInput: true,
                dateFormat: 'Y-m-d',
                allowInput: true
              }"
              class="input-custom"
              v-model="schedule.to_date"
              id="edit-todate"
              name="edit-todate"
              placeholder="To date"
            ></flat-picker>
          </base-input>
        </div>

        <div class="col-lg-3 col-sm-6 col-12" v-show="working_hours">
          <base-input label="From Time">
            <flat-picker
              slot-scope="{ focus, blur }"
              @on-open="focus"
              @on-close="blur"
              :config="{
                altFormat: formatTimeFlatPicker.altFormat,
                enableTime: true,
                noCalendar: true,
                dateFormat: formatTimeFlatPicker.dateFormat,
                time_24hr: formatTimeFlatPicker.time_24hr,
                wrap: true
              }"
              class="input-custom"
              v-model="schedule.from_time"
              id="edit-fromtime"
              name="edit-fromtime"
              placeholder="From Time"
            ></flat-picker>
          </base-input>
        </div>

        <div class="col-lg-3 col-sm-6 col-12" v-show="working_hours">
          <base-input label="To Time">
            <flat-picker
              slot-scope="{ focus, blur }"
              @on-open="focus"
              @on-close="blur"
              :config="{
                altFormat: formatTimeFlatPicker.altFormat,
                enableTime: true,
                noCalendar: true,
                dateFormat: formatTimeFlatPicker.dateFormat,
                time_24hr: formatTimeFlatPicker.time_24hr,
                wrap: true
              }"
              class="input-custom"
              v-model="schedule.to_time"
              id="edit-totime"
              name="edit-tomtime"
              placeholder="To Time"
            ></flat-picker>
          </base-input>
        </div>
        <div class="col-lg-12" v-if="view_custom">
          <div class="card mt-2">
            <h4 class="underline">Custom Frecuency</h4>
            <div class="row">
              <div class="col-lg-4 col-sm-12 col-12">
                <label for class="title-label-np">Repeat Every</label>
                <div class="row">
                  <div class="col-xl-5 col-sm-4 col-4">
                    <BaseNumberInput
                      v-model.number="schedule.custom.repeat_every"
                      id="edit-schedule_custom_times"
                      name="edit-schedule_custom_times"
                      placeholder="Every"
                    />
                  </div>

                  <div class="col-xl-7 col-sm-8 col-8">
                    <WSelect
                      placeholder
                      v-model="schedule.custom.repeat_frecuency"
                      id="edit-schedule_custom_frequency"
                      name="edit-schedule_custom_frequency"
                      style="width: 100%"
                    >
                      <el-option
                        v-for="option in customrepeat"
                        :value="option.value"
                        :label="option.label"
                        :key="option.label"
                      ></el-option>
                    </WSelect>
                  </div>
                </div>
              </div>

              <div
                class="col-lg-8 col-sm-12 col-12 mb-4 group-check"
                v-if="schedule.custom.repeat_frecuency !== 'day'"
              >
                <label for class="title-label-np">Repeat On</label>
                <button-checkbox
                  v-model="schedule.custom.repeat_on.sunday"
                  class="d-inline-block btn-check"
                  >S</button-checkbox
                >

                <button-checkbox
                  v-model="schedule.custom.repeat_on.monday"
                  class="d-inline-block btn-check"
                  >M</button-checkbox
                >

                <button-checkbox
                  v-model="schedule.custom.repeat_on.tuesday"
                  class="d-inline-block btn-check"
                  >T</button-checkbox
                >

                <button-checkbox
                  v-model="schedule.custom.repeat_on.wednesday"
                  class="d-inline-block btn-check"
                  >W</button-checkbox
                >

                <button-checkbox
                  v-model="schedule.custom.repeat_on.thursday"
                  class="d-inline-block btn-check"
                  >T</button-checkbox
                >

                <button-checkbox
                  v-model="schedule.custom.repeat_on.friday"
                  class="d-inline-block btn-check"
                  >F</button-checkbox
                >

                <button-checkbox
                  v-model="schedule.custom.repeat_on.saturday"
                  class="d-inline-block btn-check"
                  >S</button-checkbox
                >
              </div>
              <div class="col-lg-12">
                <label for class="title-label-np">Ends</label>

                <div class="row">
                  <div class="col-lg-4 col-sm-12 col-12">
                    <base-radio
                      class="mr-5 ml-3"
                      name="never"
                      value="never"
                      v-model="schedule.custom.end"
                      >Never</base-radio
                    >
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-4 col-sm-4 col-4 align-self-center">
                    <base-radio
                      class="ml-3 mt-2"
                      name="on"
                      value="on"
                      v-model="schedule.custom.end"
                      >On</base-radio
                    >
                  </div>
                  <div class="col-lg-3 col-sm-6 col-8 align-self-center">
                    <base-input class="mb-0 mt-2">
                      <flat-picker
                        slot-scope="{ focus, blur }"
                        @on-open="focus"
                        @on-close="blur"
                        :config="{
                          altFormat: formatDateFlatPicker,
                          altInput: true,
                          dateFormat: 'Y-m-d',
                          allowInput: true
                        }"
                        class="input-custom"
                        v-model="schedule.custom.end_on"
                        id="edit-end_on"
                        name="edit-end_on"
                        placeholder="End On"
                      ></flat-picker>
                    </base-input>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-4 col-sm-4 col-4 align-self-center">
                    <base-radio
                      class="ml-3 mt-1"
                      name="after"
                      value="after"
                      v-model="schedule.custom.end"
                      >After Ocurrencies</base-radio
                    >
                  </div>
                  <div class="col-lg-3 col-sm-6 col-8 align-self-center">
                    <BaseNumberInput
                      v-model.number="schedule.custom.end_after"
                      class="mb-0 mt-1"
                      id="edit-schedule_custom_end_after"
                      name="edit-schedule_custom_end_after"
                      placeholder="Every"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-12">
          <label class="title-label-np">Color</label>

          <div class="buttons-colors">
            <button-radio-group-colors
              :options="colors"
              v-model="schedule.color"
            ></button-radio-group-colors>
          </div>
        </div>
      </div>

      <div class="border-top pt-3 mt-3">
        <div class="row">
          <div class="col-xl-8 col-lg-8 col-md-8 col-sm-8 col-12 alinmov1">
            <base-button
              type="outline-neutral"
              class="min-button mr-2"
              @click="closedModal"
            >
              <i class="flaticon-cancel"></i> Close
            </base-button>

            <base-button
              type="outline-neutral"
              class="min-button btn-line-danger mr-2"
              @click="optionDelete()"
            >
              <i class="flaticon-delete"></i> Remove
            </base-button>
          </div>
          <div
            class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12 mt-sm-0 mt-2  alinmov2"
          >
            <base-button
              type="primary"
              class="min-button"
              @click="optionUpdate"
            >
              <i class="flaticon-floppy-disk"></i>Save
            </base-button>
          </div>
        </div>
      </div>
    </modal>
    <modal
      :show="selectModal"
      size="sm"
      @close="closeMiniModal"
      footerClasses="py-2 col-12"
      bodyClasses=" py-4"
    >
      <template slot="header">
        <h4 class="underline mb-0">{{ actionLabel }} Recurring Event</h4>
      </template>
      <div class="col-12">
        <base-radio name="only" id="only" class="mb-2" v-model="select"
          >This Event</base-radio
        >
        <base-radio name="onlyNext" id="onlyNext" class="mb-2" v-model="select"
          >This and following events</base-radio
        >
        <base-radio
          name="all"
          id="all"
          v-model="select"
          v-if="action === 'delete'"
          >All events</base-radio
        >
      </div>

      <template slot="footer">
        <div class="col-xl-6">
          <base-button
            type="outline-neutral"
            class="min-button"
            @click="selectModal = false"
          >
            <i class="flaticon-cancel"></i> Close
          </base-button>
        </div>
        <div class="col-xl-6 text-right">
          <base-button
            type="primary"
            class="min-button"
            @click="updateSchedule"
            :disabled="disableButton"
            v-if="action === 'edit'"
          >
            <i class="flaticon-check-2"></i> Accept
          </base-button>

          <base-button
            type="primary"
            class="min-button"
            :disabled="disableButton"
            @click="deletedEvent()"
            v-else
          >
            <i class="flaticon-check-2"></i> Accept
          </base-button>
        </div>
      </template>
    </modal>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import lodash from "lodash";
import endpoint from "../../Commons/Services/index";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import moment from "moment-timezone";
import { DatePicker, TimeSelect } from "element-ui";
import { required } from "vuelidate/lib/validators";

import WSelect from "@/components/Select";
WSelect.computed.readonly = function() {
  const isIE = !this.$isServer && !Number.isNaN(Number(document.documentMode));
  return (
    !this.filterable ||
    this.multiple ||
    (!isIE && !this.visible && !this.remote)
  );
};
export default {
  name: "EditSchedule",
  props: {
    value: {
      type: Boolean,
      default: false
    },
    drivers: {
      type: Array,
      default: []
    },
    scheduleUser: {
      type: Object,
      default: null
    },
    event: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      schedule: {
        driver: "",
        working_hours: "custom",
        working_days: "daily",
        current_shift: false,
        status: true,
        start: "",
        from_date: moment().format("YYYY-MM-DD"),
        from_time: "12:00",
        to_date: moment().format("YYYY-MM-DD"),
        to_time: "19:00",
        custom_frecuency: false,
        color: "sh-blue",
        custom: {
          repeat_every: 1,
          repeat_frecuency: "week",
          repeat_on: {
            monday: false,
            tuesday: false,
            wednesday: false,
            thursday: false,
            friday: false,
            saturday: false,
            sunday: false
          },
          end: "on",
          end_on: moment()
            .add(7, "days")
            .format("YYYY-MM-DD"),
          end_after: 1
        },
        events: [],
        timezone: ""
      },
      _id: null,
      event_id: null,
      scheduleCopy: null,
      working_hours: true,
      working_days: false,
      view_custom: false,
      show: false,
      from_date: moment().format("YYYY-MM-DD"),
      to_date: moment().format("YYYY-MM-DD"),
      workhours: [
        { value: "full_day", label: "Full Day (7am to 7pm)" },
        { value: "morning", label: "Morning (7am to 4pm)" },
        { value: "evening", label: "Evening (5pm to 08pm)" },
        { value: "night", label: "Night (10pm to 7am)" },
        { value: "custom", label: "Custom" }
      ],
      workdays: [
        { value: "daily", label: "Daily (7 days a week)" },
        { value: "weekdays", label: "Weekdays (M-F)" },
        { value: "weekends", label: "Weekends (Saturday & Sunday)" },
        { value: "custom", label: "Custom" }
      ],
      customrepeat: [
        { value: "day", label: "Day" },
        { value: "week", label: "Week" },
        { value: "month", label: "Month" }
      ],
      colors: [
        { value: "sh-green-lg", color: "sh-green-lg" },
        { value: "sh-green", color: "sh-green" },
        { value: "sh-green-light", color: "sh-green-light" },
        { value: "sh-blue", color: "sh-blue" },
        { value: "sh-blue-purple", color: "sh-blue-purple" },
        { value: "sh-purple", color: "sh-purple" },
        { value: "sh-purple-light", color: "sh-purple-light" },
        { value: "sh-bordo", color: "sh-bordo" },
        { value: "sh-red", color: "sh-red" },
        { value: "sh-orange", color: "sh-orange" },
        { value: "sh-yellow", color: "sh-yellow" },
        { value: "sh-brown-light", color: "sh-brown-light" },
        { value: "sh-bronze", color: "sh-bronze" },
        { value: "sh-brown", color: "sh-brown" }
      ],
      selectModal: false,
      select: "only",
      actionLabel: "Edit",
      action: "edit",
      disableButton: false
    };
  },
  created() {
    //resetear valores
    this.scheduleCopy = lodash.cloneDeepWith(this.schedule);
  },
  watch: {
    value: function(newVal, oldVal) {
      if (!newVal && oldVal) {
        this.$v.schedule.$reset();
        this.show = true;
      } else if (newVal && !oldVal) {
        this.show = true;
      }
    },
    "schedule.working_hours": function(newVal, oldVal) {
      if (newVal !== "") {
        this.working_hours = true;
      }
    },
    "schedule.working_days": function(newVal, oldVal) {
      if (newVal === "custom" && oldVal == "my_custom") {
      }

      if (newVal === "custom") {
        this.view_custom = true;
        this.schedule.custom_frecuency = true;
        this.working_days = true;
      } else {
        this.schedule.custom_frecuency = false;
        this.view_custom = false;
        this.working_days = false;
      }
    },
    scheduleUser: function(newVal, oldVal) {
      if (newVal !== null) {
        let schedule = newVal;
        this._id = newVal._id;
        this.event_id = this.event.id;
        if (schedule.working_days === "custom") {
          schedule.working_days = "my_custom";
          this.workdays.unshift({ value: "my_custom", label: "My Custom" });
        }

        /**
         * start time
         */
        this.schedule.from_date = this.event.start;
        this.schedule.to_date = this.event.end;
        this.schedule.driver = schedule.driver;
        this.schedule.start = schedule.start;
        this.schedule.working_days = schedule.working_days;
        this.schedule.current_shift = schedule.current_shift;
        this.schedule.status = schedule.status;
        this.schedule.from_time = this.getTime(this.event.start);
        this.schedule.to_time = this.getTime(this.event.end);
        this.schedule.working_hours = this.getWorkingHours(
          this.schedule.from_time,
          this.schedule.to_time
        );
        this.schedule.custom_frecuency = schedule.custom_frecuency;
        this.schedule.color = this.event.className;
        this.schedule.timezone = schedule.timezone;
        this.schedule.custom.repeat_on = schedule.custom.repeat_on;
        this.schedule.custom.repeat_every = schedule.custom.repeat_every;
        this.schedule.custom.repeat_frecuency = lodash.cloneDeepWith(
          schedule.custom.repeat_frecuency
        );
        this.schedule.custom.end = schedule.custom.end;
        this.schedule.custom.end_on = schedule.custom.end_on;
        this.schedule.custom.end_after = schedule.custom.end_after;
      }
    }
  },
  methods: {
    async updateSchedule() {
      try {
        this.disableButton = true;
        let action = this.select === "onlyNext" ? "new" : "update";
        let schedule = lodash.cloneDeepWith(this.schedule);
        schedule.working_days =
          schedule.working_days == "my_custom"
            ? "custom"
            : schedule.working_days;
        schedule["from_date"] = moment(
          moment(`${schedule.from_date} ${schedule.from_time}`).utc(true)
        )
          .set("hour", moment(schedule.from_time, "h:mm A").get("hour"))
          .set("minute", moment(schedule.from_time, "h:mm A").get("minutes"))
          .utc(true)
          .format("YYYY-MM-DDTHH:mm:ss");

        schedule["to_date"] = moment(
          moment(`${schedule.to_date} ${schedule.to_time}`).utc(true)
        )
          .utc(true)
          .set("hour", moment(schedule.to_time, "h:mm A").get("hour"))
          .set("minute", moment(schedule.to_time, "h:mm A").get("minutes"))
          .format("YYYY-MM-DDTHH:mm:ss");

        if (
          moment(schedule.from_date).isSameOrBefore(schedule.to_date, "days")
        ) {
          let { data } = await endpoint.drivers.services.updateSchedule(
            this._id,
            schedule,
            this.event.id,
            this.select,
            action,
            this.sesion.token
          );
          if (data.status) {
            this.$emit("update", true);
          } else {
            this.$emit("update", false);
          }
          this.disableButton = false;
          this.closedModal();
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The start date cannot be greater than the end date",
            icon: "flaticon-remove"
          });
          this.disableButton = false;
          return false;
        }
      } catch (error) {
        if (error.response) {
          let { data } = error.response;
          if (data.code === 401) {
            this.$emit("update", false);
            this.disableButton = false;
            this.closedModal();
            return false;
          } else {
            this.$emit("update", false);
            this.disableButton = false;
            this.closedModal();
            return false;
          }
        } else {
          this.$emit("update", false);
          this.disableButton = false;
          this.closedModal();
          return false;
        }
      }
    },
    async deletedEvent() {
      try {
        this.disableButton = true;
        let { data } = await endpoint.drivers.services.deletedEvent(
          this._id,
          this.event_id,
          this.select,
          this.sesion.token
        );
        if (data.status) {
          this.$emit("delete", true);
        } else {
          this.$emit("delete", false);
        }
        this.disableButton = false;
        this.closedModal();
      } catch (error) {
        this.disableButton = false;
        this.$emit("delete", false);
      }
    },
    clearschedule() {
      this.schedule = lodash.cloneDeepWith(this.scheduleCopy);
    },
    optionUpdate() {
      this.actionLabel = "Edit";
      this.action = "edit";
      this.selectModal = !this.selectModal;
    },
    async optionDelete() {
      this.actionLabel = "Delete";
      this.action = "delete";
      this.selectModal = !this.selectModal;
    },
    closeMiniModal() {
      this.selectModal = !this.selectModal;
    },
    closedModal() {
      if (
        this.workdays.map(element => element.value).indexOf("my_custom") > -1
      ) {
        this.workdays.shift();
      }
      this.schedule = lodash.cloneDeepWith(this.scheduleCopy);
      this.select = "only";
      this.selectModal = false;
      this.show = false;
      this.clearschedule();
    },
    getTime(date) {
      return moment(date)
        .utc(true)
        .format("HH:mm");
    },
    getWorkingHours(from_time, to_time) {
      if (from_time === "07:00" && to_time === "19:00") {
        return "full_day";
      } else if (from_time === "07:00" && to_time === "16:00") {
        return "morning";
      } else if (from_time === "17:00" && to_time === "20:00") {
        return "evening";
      } else if (from_time === "22:00" && to_time === "07:00") {
        return "night";
      } else {
        return "custom";
      }
    },
    ...mapActions([]),
    ...mapMutations(["setLoad"])
  },
  computed: {
    ...mapGetters(["sesion", "settings"]),
    formatDateFlatPicker: function() {
      if (this.settings) {
        if (this.settings.dateFormat === "DD-MMM-YYYY") {
          return "d-M-Y";
        } else if (this.settings.dateFormat === "DD/MM/YYYY") {
          return "d/m/Y";
        } else {
          return "m/d/Y";
        }
      } else {
        return "d-M-Y";
      }
    },
    formatTimeFlatPicker: function() {
      if (this.settings) {
        if (this.settings.timeFormat === "hh:mm A") {
          return {
            altFormat: "G:i K",
            dateFormat: "G:i K",
            time_24hr: false
          };
        } else {
          return {
            altFormat: "H:i",
            dateFormat: "H:i",
            time_24hr: true
          };
        }
      } else {
        return {
          altFormat: "G:i K",
          dateFormat: "G:i K",
          time_24hr: false
        };
      }
    },
    render: function() {
      if (this.sesion.role === "admin") {
        return true;
      } else {
        return this.settings.status;
      }
    }
  },
  components: {
    [DatePicker.name]: DatePicker,
    [TimeSelect.name]: TimeSelect,
    flatPicker,
    WSelect
  },
  validations: {
    schedule: {
      driver: {
        required
      },
      working_hours: {
        required
      },
      working_days: {
        required
      }
    }
  }
};
</script>
